/**
 * Canonical outbound URL for The Real Startup Book (2nd Edition).
 *
 * Centralized here so the footer link, post-game CTA, and any future
 * placements resolve the same destination. Mirrors the sibling
 * games-and-tools rollout pattern (plinkromatic's helpers/common/rsb.ts).
 *
 * Points at the owned launch funnel on kromatic.com so the copy's
 * "free online" promise holds and so resolveKromaticSiteUrl can rewrite
 * it to the staging host on staging builds, exactly like the other
 * kromatic.com links in the footer.
 */
export const RSB_URL = 'https://kromatic.com/download/the-real-startup-book';
